<template>
  <v-container>
    <div v-if="!loadingData">
      <div v-if="searchContentItems.length > 0">
        <h2 class="text-center my-6">{{ this.$route.query.kay }}</h2>
        <v-row>
          <v-col
            cols="12"
            md="4"
            v-for="(item, index) in searchContentItems"
            :key="index"
          >
            <v-card height="270" elevation="0" style="border: 1px solid #ccc">
              <v-card-title style="height: 85px !important ; display: inline-block;">
                <ul class="mx-4">
                  <li style="color: #8bc34a ; font-size: 14px;     word-break: keep-all;">
                    <b
                      >{{ item.book.bookname.substring(0, 60) }}
                      <span v-if="(item.book.bookname.length > 60)">...</span></b
                    >
                  </li>
                </ul>
              </v-card-title>
              <v-card-text>
                <p style="font-size:13px ;     height: 40px;">  
                  <b
                    >{{ item.content.substring(0, 7 ) == ' مجهول ' ? item.content.substring(6, 66) : item.content.substring(0, 60) }}
                    <span v-if="item.content.length > 60">...</span>
                  </b>
                </p>
                <p class="text-caption" style="height: 60px">
                  {{ item.content.substring(0, 7 ) == ' مجهول ' ? item.content.substring(6, 257) : item.content.substring(0, 250) }}
                  <span v-if="item.content.length > 250">...</span>
                </p>
              </v-card-text>
              <v-card-actions
                class="justify-end"
                style="position: relative; top: 10px"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn style="font-size:12px" small class="white--text float-left px-4" @click="dialogData.bookId = item.book.bookid" color="#ff9800" dark v-bind="attrs" v-on="on">
                      أقرا المزيد
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="goToBookBySearchKey(item.versionid, item.href)"
                    >
                      <v-list-item-title>صفحة جديدة</v-list-item-title>
                    </v-list-item>

                    <v-list-item 
                      @click=" dialogData.dialogStatus = true ; dialogData.href = item.href ">
                      <v-list-item-title>مربع حوار</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <!-- <v-btn style="font-size:12px" small class="white--text float-left px-4" @click="goToBookBySearchKey(item.versionid , item.href)" color="#ff9800">اقرأ المزيد</v-btn> -->
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-pagination
            v-model="page"
            :length="PagesNumber"
            :total-visible="7"
            @input="changePage($event)"
          ></v-pagination>
        
        <OpenBook v-model="dialogData" v-if="dialogData.dialogStatus == true " />
      </div>
      <div v-else>
        <v-card-text class="px-0 py-1">
          <span class="noDataText">{{ $t("home.noDataSection") }}</span>
        </v-card-text>
      </div>
    </div>
    <div v-else>
       <v-skeleton-loader
          type="card-avatar, article, actions"
        ></v-skeleton-loader>
    </div>
  </v-container>
</template>

<script>
import OpenBook from "@/components/Books/OpenBook";
export default {
  data() {
    return {
      searchContentItems: [],
      dialogData: {
        href : '' ,
        dialogStatus: false,
        bookId: null,
      },
      PagesNumber : 0 ,
      page: 1,
      pageUrl: 1,
      loadingData : false
    };
  },
  components: {
    OpenBook,
  },

  created() {
    this.searchBook();
  },
  methods: {
    goToBookBySearchKey(versionid, pageNume) {
      this.$router.push("read-book/" + versionid + "?page=" + pageNume);
    },
    changePage(val) {
      this.pageUrl = val;
      this.searchBook();
    },

    searchBook() {
      this.loadingData = true 
      let queryStr = `?page=${this.pageUrl}&`;
      if (this.$route.query.category_id) {
        queryStr += `filter[book.categories.categoryid]=${this.$route.query.category_id}&`;
      }
      if (this.$route.query.auther_id) {
        queryStr += `filter[book.author.authorid]=${this.$route.query.auther_id}&`;
      }
      if (this.$route.query.book_id) {
        queryStr += `filter[book.bookid]=${this.$route.query.book_id}&`;
      }
      let DataForm = {
        Param: { word: this.$route.query.kay },
        API: "/search" + queryStr,
      };
      this.$store
        .dispatch("PostToAPI", DataForm)
        .then((res) => {
          this.loadingAdd = false;
          this.searchContentItems = res.data.data;
          this.PagesNumber = res["data"]["meta"]["last_page"];
          // this.$store.dispatch("PushSuccessMsg", this.$t('public.successSeved'));
          // this.$router.push({ name: "MyBooks" }).catch(() => {});
        })
        .catch((error) => {
          this.loadingAdd = false;
          this.$store.dispatch(
            "PushErrorMsg",
            error.data.data[Object.keys(error.data.data)[0]]
          );
        }).finally(() =>{
          this.loadingData = false 
        });
    },
  },
};
</script>